module.exports = __webpack_public_path__ + "static/media/bussiness-home-vector.35b848f3.png";